// DEVELOPER NOTE: We are descoping the reschedule feature for now, so the related code is commented out but left in place for future reference.
// There was a copy change as well, the original text was:
// "Your session has been successfully canceled. You can book a new one anytime through the app or using the link below."
// which is now changed to:
// "Your session has been successfully canceled. You can book a new one anytime through the app"

import styles from "./CancelSuccessScreen.module.scss";

// import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";
// import { Route } from "@/routes/$sessionCode/cancel/$cancelUuid/success";

export const CancelSuccessScreen = () => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  // const { sessionCode } = Route.useParams();
  // const { rescheduleUuid } = Route.useSearch();

  // const handleReschedulePress = () => {
  //   if (!rescheduleUuid) {
  //     return;
  //   }

  //   navigate({
  //     to: `/${sessionCode}/reschedule/${rescheduleUuid}`,
  //   });
  // };
  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("cancelSuccess.title")}</span>

        <span className={styles.description}>
          {t("cancelSuccess.description")}
        </span>

        {/* <AppButton onClick={handleReschedulePress} variant="critical">
          {t("cancelSuccess.rescheduleButton")}
        </AppButton> */}
      </div>
    </PageContainer>
  );
};
